import { useDispatch } from "react-redux";
import { editProfile, reloadUser } from "@actions/user-actions";

export function useReloadUser() {
  const dispatch = useDispatch();

  return () => dispatch(reloadUser());
}

export function useEditProfile() {
  const dispatch = useDispatch();

  return async (userData) => dispatch(editProfile(userData));
}
